export default __webpack_public_path__ + "static/media/check-box.29d839b1.svg";